import { initializeApp, deleteApp } from "firebase/app";
import { getAuth, inMemoryPersistence, setPersistence, signInWithCustomToken } from "firebase/auth";
import { doc, getFirestore, onSnapshot } from "firebase/firestore";
import { getFirebaseSession } from "api/notification";
import firebaseConfig, { firebaseConfigured } from "./firebaseConfig";

let nextAppId = 0;

export const listenForLiveNotificationFeed = (userId, onSignal) => {
  if (!userId || !firebaseConfigured) return () => {};

  const app = initializeApp(firebaseConfig, `notification-feed-${++nextAppId}`);
  const auth = getAuth(app);
  let active = true;
  let unsubscribe = () => {};

  (async () => {
    const { customToken } = await getFirebaseSession();
    if (!active) return;
    await setPersistence(auth, inMemoryPersistence);
    if (!active) return;
    const credential = await signInWithCustomToken(auth, customToken);
    if (!active) return;
    if (credential.user.uid !== String(userId)) {
      throw new Error("Firebase session user does not match the current user");
    }
    unsubscribe = onSnapshot(
      doc(getFirestore(app), "notificationSignals", String(userId)),
      (snapshot) => {
        if (active && snapshot.exists()) onSignal(snapshot.data().notificationId);
      },
      (error) => console.warn("Live notification feed disconnected:", error),
    );
  })().catch((error) => {
    if (active) console.warn("Live notification feed unavailable:", error);
  });

  return () => {
    active = false;
    unsubscribe();
    deleteApp(app).catch(() => {});
  };
};
